/**
 * Repositions the manufacturer element below the product title
 * This function finds the manufacturer element in the product form container
 * and positions it absolutely below the product title, similar to price positioning
 */
document.addEventListener('DOMContentLoaded', function () {
    // Function to reposition the manufacturer
    function repositionManufacturer() {
        // Only apply on screens below 968px width
        if (window.innerWidth >= 968) {
            return;
        }

        const productTitle = document.querySelector('.js-manufacturer-title');

        const manufacturerContainer = document.querySelector('.product-form__container.manufacturer');

        const wrapper = document.querySelector('.manufacturer__wrapper');

        if (productTitle && manufacturerContainer && wrapper) {
            // Set initial opacity to 0
            manufacturerContainer.style.opacity = '0';
            manufacturerContainer.style.transition = 'opacity 0.3s ease';
            
            const titleRect = productTitle.getBoundingClientRect();
            manufacturerContainer.style.position = 'absolute';
            manufacturerContainer.style.top = `${titleRect.bottom + window.scrollY + 5}px`; // 5px gap
            
            // Set opacity to 1 after positioning is complete
            setTimeout(() => {
                manufacturerContainer.style.opacity = '1';
            }, 50);
        }
    }

    // Run the function on page load
    repositionManufacturer();

    // Also run it on window resize to maintain correct positioning
    window.addEventListener('resize', repositionManufacturer);

    // Run it after a short delay to ensure all elements are properly rendered
    setTimeout(repositionManufacturer, 300);
});
